<template>

    <div>
        <div class="form-row mb-1">
            <div class="col">
                <input type="file" class="form-control" @change="onFileChange">
            </div>
            <div class="col" v-if="handler">
                <img :src="handler">
                <span class="close" @click="removeImage">&times;</span>
            </div>
        </div>
    </div>

</template>
<style scoped>
.close {
    position: absolute;
    top: 0;
    z-index: 2;
    right: 10px;
    background: #fff;
    border-radius: 50px;
    width: 1.5rem;
    text-align: center;
    cursor: pointer;
}

</style>

<script>
import axios from 'axios';

export default {
  props: ['config', 'name', 'value'],
  data(){
      return {
          handler:'',
      }
  },
  mounted(){
      if(!this.value) return;
      var match = this.value.match(/url\(['"]?([^)]+?)['"]?\)/);
      if(match){
          this.handler = match[1];
      }

  },
  methods:{
      removeImage(){
          this.handler = '';
          this.$emit('change','');
      },
    change(){
        var newval = `url(${this.handler})`;
        this.$emit('change',newval);
    },

    onFileChange(event,field){
        var files = event.target.files || event.dataTransfer.files;

        var file = files[0];
        if(!file) return;
        event.target.value='';

        var reader = new FileReader();
        reader.onload = (e) => {
            var base64 =  e.target.result;
            var data = {
                name:file.name,
                content:base64
            }

            axios.post('/api/upload',data).then((response)=> {
                this.handler = response.data;
                this.change();
            }).catch((error) =>  {
                console.error(error);
                if(error.response) alert(error.response.data);
            })

        }
        reader.readAsDataURL(file);
    }

  }

}
</script>
